var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62504 16.8126C4.38752 16.8126 0.9375 13.3626 0.9375 9.12504C0.9375 4.88752 4.38752 1.4375 8.62504 1.4375C12.8626 1.4375 16.3126 4.88752 16.3126 9.12504C16.3126 13.3626 12.8626 16.8126 8.62504 16.8126ZM8.62504 2.56251C5.00252 2.56251 2.06251 5.51002 2.06251 9.12504C2.06251 12.7401 5.00252 15.6876 8.62504 15.6876C12.2476 15.6876 15.1876 12.7401 15.1876 9.12504C15.1876 5.51002 12.2476 2.56251 8.62504 2.56251Z",
    fill: "#4E515F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 17.5626C16.3576 17.5626 16.2151 17.5101 16.1026 17.3976L14.6026 15.8976C14.3851 15.6801 14.3851 15.3201 14.6026 15.1026C14.8201 14.8851 15.1801 14.8851 15.3976 15.1026L16.8976 16.6026C17.1151 16.8201 17.1151 17.1801 16.8976 17.3976C16.7851 17.5101 16.6426 17.5626 16.5001 17.5626Z",
    fill: "#4E515F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a0928a49d61a4ec19c1809faa207ce5e.svg";
export { ForwardRef as ReactComponent };